import React, { useState } from 'react'
import noProfile from "../../Images/noProfile.jpg"

const ViewAdmin = ({ showViewAdmin, setShowViewAdmin, selectedAdmin }) => {

    const [open, setOpen] = useState(showViewAdmin);

    const closeViewModal = () => {
        setOpen(false)
        setShowViewAdmin(false)
    }


    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 rounded-2xl">
        <div className="bg-white rounded-lg shadow-lg w-[900px] h-[600px] flex flex-col rounded-t-2xl">
          
          {/* Header */}
          <h3 className="text-xl font-bold text-center bg-gradient-to-br from-teal-950 to-teal-500 py-2 text-white rounded-t-2xl">
            View User
          </h3>
      
          {/* Scrollable Content */}
          <div className="flex-1 overflow-y-auto p-8 scrollbar-hidden">
            <form>

              <div className="flex gap-2 ">
                <div className="w-full">
                  <label className="block mb-1">User Name</label>
                  <input
                    type="text"
                    name="name"
                    className="border border-gray-800 p-2 w-full"
                    value={selectedAdmin.name || 'N/A'}
                    disabled
                  />
                </div>

                <div className="w-full">
                  <label className="block mb-1">User Role</label>
                  <input
                    type="text"
                    name="role"
                    className={`border border-gray-800 p-2 w-full ${selectedAdmin.isAdmin ? 'bg-blue-200' : 'bg-gray-200'}`}
                    value={selectedAdmin.isAdmin ? 'Admin' : 'Regular User'}
                    disabled
                  />
                </div>
              </div>

              <div className="w-full">
                <label className="block mb-1 mt-2">Email:</label>
                <input
                  type="email"
                  name="email"
                  className="border border-gray-800 p-2 w-full"
                  value={selectedAdmin.email || 'N/A'}
                  disabled
                />
              </div>

              <div className="flex gap-2 ">
                <div className="w-full">
                  <label className="block mb-1 mt-2">Provider</label>
                  <input
                    type="text"
                    name="provider"
                    className={`border border-gray-800 p-2 w-full ${
                      selectedAdmin.provider === 'google' ? 'bg-red-100' :
                      selectedAdmin.provider === 'firebase' ? 'bg-orange-100' :
                      'bg-gray-100'
                    }`}
                    value={selectedAdmin.provider || 'N/A'}
                    disabled
                  />
                </div>

                {/* <div className="w-full">
                  <label className="block mb-1 mt-2">Firebase ID</label>
                  <input
                    type="text"
                    name="firebaseId"
                    className="border border-gray-800 p-2 w-full font-mono text-sm"
                    value={selectedAdmin.firebaseId ? `${selectedAdmin.firebaseId.substring(0, 20)}...` : 'N/A'}
                    disabled
                    title={selectedAdmin.firebaseId || 'N/A'}
                  />
                </div> */}
              </div>

              {/* <div className="w-full">
                <label className="block mb-1 mt-2">User ID</label>
                <input
                  type="text"
                  name="userId"
                  className="border border-gray-800 p-2 w-full font-mono text-sm"
                  value={selectedAdmin._id || selectedAdmin.id || 'N/A'}
                  disabled
                />
              </div> */}
      
              <div className="w-full mt-2">
                <label className="block mb-1">Profile Picture</label>
                {selectedAdmin?.profileImageUrl ? (
                  <img
                    src={selectedAdmin?.profileImageUrl}
                    alt="Profile Preview"
                    className="h-48 w-48 object-cover rounded-lg ml-4"
                  />
                ) : (
                  <img
                    src={noProfile}
                    alt="Profile Preview"
                    className="h-20 w-20 object-cover ml-4"
                  />
                )}
              </div>
      
            </form>
          </div>
      
          {/* Fixed Footer Button */}
          <div className="flex justify-end p-4 border-t">
            <button
              onClick={closeViewModal}
              className="bg-gray-300 text-black w-52 py-2 px-4 rounded-md hover:bg-gray-400 transition duration-200"
            >
              Close
            </button>
          </div>
        </div>
      </div>
      
    )
}

export default ViewAdmin